import styled from "styled-components";

export const FormSectionColumn = styled.div`
    display: flex;
    flex-direction:column;
`;

export const FormSectionInputs = styled.section`
    display: flex;
    flex-direction:column;
    width:33%;
    height:100%;
    padding: 2px;
    margin: 2px;
    min-width:200px;
`;

export const FormSectionRow = styled.div`
    display: flex;
    flex-direction:row;
`;

export const FormSectionTables = styled.section`
    display: flex;
    flex-direction:row;
    width: 66%;
    height:100%;
    padding: 2px;
    margin: 2px;
`;

export const WideFormPage = styled.div`
    display:flex;
    margin-top:50px;
    flex-wrap: wrap;
    min-width:1050px;
`;